import { createContext, useContext, useEffect, useState } from 'react';
import { api } from '../api/client.js';
import { applyAccentPalette } from '../lib/colorTheme.js';

const SettingsContext = createContext(null);

const DEFAULTS = {
  site_name: 'Exotic Pet World',
  tagline: 'Spesialis Edukasi Satwa Interaktif, Pameran Eksotis, & Kontes Hewan Ceria.',
  app_color: '#4A7A3A',
  app_icon: 'pets',
  app_logo_mode: 'icon',
  app_logo: '',
  alamat: '',
  telepon: '',
  email: '',
  whatsapp: '',
  instagram: '',
  facebook: '',
  youtube: '',
  tiktok: '',
  jam_operasional: 'Senin - Jumat: 08:00 - 17:00',
  maps_label: '',
  maps_view_url: '',
  maps_embed_url: '',
};

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(DEFAULTS);
  const [loaded, setLoaded] = useState(false);

  const refresh = () => api.get('/settings')
    .then(({ data }) => setSettings({ ...DEFAULTS, ...data.settings }))
    .catch(() => {});

  useEffect(() => {
    refresh().finally(() => setLoaded(true));
  }, []);

  useEffect(() => {
    applyAccentPalette(settings.app_color);
  }, [settings.app_color]);

  return (
    <SettingsContext.Provider value={{ settings, loaded, refresh }}>
      {children}
    </SettingsContext.Provider>
  );
}

export function useSettings() {
  return useContext(SettingsContext);
}
